import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  USUARIO_PERFIL_DELETAR_REGISTRO_BEGIN,
  USUARIO_PERFIL_DELETAR_REGISTRO_SUCCESS,
  USUARIO_PERFIL_DELETAR_REGISTRO_FAILURE,
  USUARIO_PERFIL_DELETAR_REGISTRO_DISMISS_ERROR,
} from './constants';

export function deletarRegistro(callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIO_PERFIL_DELETAR_REGISTRO_BEGIN,
    callback,
  };
}

export function dismissDeletarRegistroError() {
  return {
    type: USUARIO_PERFIL_DELETAR_REGISTRO_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIO_PERFIL_DELETAR_REGISTRO_BEGIN actions
export function* doDeletarRegistro(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = {};
  } catch (err) {
    yield put({
      type: USUARIO_PERFIL_DELETAR_REGISTRO_FAILURE,
      data: { error: err },
    });

    if(action.callback){
      action.callback(USUARIO_PERFIL_DELETAR_REGISTRO_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIO_PERFIL_DELETAR_REGISTRO_SUCCESS,
    data: res,
  });

  if(action.callback){
    action.callback(USUARIO_PERFIL_DELETAR_REGISTRO_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchDeletarRegistro() {
  yield takeLatest(USUARIO_PERFIL_DELETAR_REGISTRO_BEGIN, doDeletarRegistro);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIO_PERFIL_DELETAR_REGISTRO_BEGIN:
      return {
        ...state,
        deletarRegistroPending: true,
        deletarRegistroError: null,
      };

    case USUARIO_PERFIL_DELETAR_REGISTRO_SUCCESS:
      return {
        ...state,
        registro: action.data,
        deletarRegistroPending: false,
        deletarRegistroError: null,
      };

    case USUARIO_PERFIL_DELETAR_REGISTRO_FAILURE:
      return {
        ...state,
        deletarRegistroPending: false,
        deletarRegistroError: action.data.error,
      };

    case USUARIO_PERFIL_DELETAR_REGISTRO_DISMISS_ERROR:
      return {
        ...state,
        deletarRegistroError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/redux/deletarRegistro.js